
import React, { useState, useEffect } from 'react';
import { DAILY_WORDS } from '../constants';

interface WordData {
  traditional: string;
  cyrillic: string;
  meaning: string;
  pronunciation: string;
  sentence: string;
}

const WordOfTheDay: React.FC = () => {
  const [data, setData] = useState<WordData | null>(null);
  const [isVisible, setIsVisible] = useState(true);

  const getDayWord = () => {
    const dayOfYear = Math.floor((new Date().getTime() - new Date(new Date().getFullYear(), 0, 0).getTime()) / 86400000);
    const index = dayOfYear % DAILY_WORDS.length;
    setData(DAILY_WORDS[index] as any);
  };

  useEffect(() => {
    getDayWord();
  }, []);

  if (!isVisible) return (
    <button 
      onClick={() => setIsVisible(true)}
      className="fixed bottom-10 right-10 px-6 py-3 bg-slate-900 text-white text-[9px] font-bold uppercase tracking-[0.3em] hover:bg-primary transition-all z-50 shadow-2xl rounded-full"
    >
      Өдрийн үг
    </button>
  );

  return (
    <div id="word-of-the-day" className="fixed bottom-10 right-10 w-72 bg-white border border-slate-200 shadow-[0_20px_50px_rgba(0,0,0,0.1)] z-50 animate-in slide-in-from-bottom-6 duration-500 rounded-[2.5rem] overflow-hidden">
      <div className="bg-slate-900 px-6 py-4 flex justify-between items-center text-white">
        <span className="text-[9px] font-bold uppercase tracking-[0.3em] text-primary">Өдрийн үг</span>
        <button onClick={() => setIsVisible(false)} className="text-[9px] font-bold uppercase opacity-40 hover:opacity-100 transition-opacity">
          Хаах
        </button>
      </div>
      <div className="p-8 flex gap-6 items-start">
        <div className="shrink-0 flex items-center justify-center bg-slate-50 rounded-2xl p-4">
          <h4 className="vertical-script text-4xl font-bold text-slate-900">
            {data?.traditional || '...'}
          </h4>
        </div>
        <div className="flex-1 space-y-4">
          <div className="space-y-1">
            <span className="text-[8px] font-bold text-slate-400 uppercase tracking-widest">Бичлэг</span>
            <p className="text-lg font-bold text-slate-900">{data?.cyrillic}</p>
          </div>
          <div className="space-y-1">
            <span className="text-[8px] font-bold text-slate-400 uppercase tracking-widest">Утга</span>
            <p className="text-[11px] font-medium text-slate-600 leading-relaxed">{data?.meaning}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WordOfTheDay;
